import React from 'react';
import BusinessKitzLogo from '../../../assets/svg/business-kitz-logo.svg?react';
import { Grid } from '@mui/material';
import AuthFooter from '../auth-footer/AuthFooter';
import { useUser } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '../constants/routes';

interface AuthTemplateProps extends React.PropsWithChildren {
  featureItems?: JSX.Element;
}

const AuthTemplate = ({ featureItems, children }: AuthTemplateProps) => {
  const { isSignedIn } = useUser();
  if (isSignedIn) {
    return <Navigate to={ROUTES.HOME} />;
  }
  return (
    <div className='demo-auth-template'>
      <header>
        <Grid container>
          <Grid
            size={{ xs: 12 }}
            className='demo-auth-template-logo-item'
            sx={{
              '&:hover': {
                cursor: 'pointer',
              },
            }}
            onClick={() => window.open('https://www.businesskitz.com', '_blank')}
          >
            <BusinessKitzLogo />
          </Grid>
        </Grid>
      </header>
      <Grid
        container
        className='demo-auth-template-container d-flex justify-content-center align-items-center flex-grow-1 px-2'
      >
        {featureItems && (
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4 }} sx={{ p: 3 }}>
            {featureItems}
          </Grid>
        )}
        <Grid
          size={{ xs: 12, sm: 6, md: 6, lg: 4 }}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            //minHeight: '60vh',
          }}
        >
          {children}
        </Grid>
      </Grid>
      <AuthFooter />
    </div>
  );
};

export default AuthTemplate;
